module.exports = __webpack_public_path__ + "static/media/discord.f73fc7bc.png";